import qrcode from 'qrcode-generator';

/** A real QR for the till's scanner (keyboard wedge). Error correction M, auto-sized. */
export function qrSvg(text: string): string {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  return qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
}
